import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaRocket, FaInfoCircle } from "react-icons/fa";
import "./Landing.css";
import logo from "../Rasm/logo.png";
import htmlImg from "../Rasm/html.png";
import reactImg from "../Rasm/react.png";
import pythonImg from "../Rasm/python.png";
import mobileImg from "../Rasm/flutter.png";

function Landing() {
    const navigate = useNavigate();

    useEffect(() => {
        document.body.classList.add("is-landing");
        document.documentElement.classList.add("is-landing-active");

        return () => {
            document.body.classList.remove("is-landing");
            document.documentElement.classList.remove("is-landing-active");
        };
    }, []);

    return (
        <div className="landing-container">
            {/* Background Shapes */}
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>

            <nav className="landing-nav">
                <div className="landing-logo">
                    <img src={logo} alt="Suvoriy Logo" />
                    <span>SUVORIY TA'LIM</span>
                </div>
            </nav>

            <main className="landing-main">
                <section className="hero-section">
                    <h1 className="hero-title">
                        Kelajak Kasbini <br /> <span>Bugun O'rganing</span>
                    </h1>
                    <p className="hero-subtitle">
                        O'zbekistondagi eng yetakchi online ta'lim platformasi.
                        Dasturlash, dizayn va texnologiyalarni mutaxassislar yordamida o'zlashtiring.
                    </p>
                    <div className="hero-btns">
                        <button className="main-btn" onClick={() => navigate("/kirish")}>
                            <FaRocket style={{ marginRight: '8px' }} />
                            Platformaga Kirish
                        </button>
                        <button className="secondary-btn" onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}>
                            <FaInfoCircle style={{ marginRight: '8px' }} />
                            Batafsil ma'lumot
                        </button>
                    </div>
                </section>

                <section id="features" className="features-section">
                    <h2 className="section-title">Bizning Yo'nalishlar</h2>
                    <div className="feature-cards">
                        <div className="feature-card">
                            <img src={htmlImg} alt="Frontend" />
                            <h3>Frontend Development</h3>
                            <p>Zamonaviy va mukammal web-saytlar yaratishni o'rganing.</p>
                        </div>
                        <div className="feature-card">
                            <img src={pythonImg} alt="Backend" />
                            <h3>Backend Development</h3>
                            <p>Murakkab tizimlar va ma'lumotlar bazasi bilan ishlash asoslari.</p>
                        </div>
                        <div className="feature-card">
                            <img src={reactImg} alt="Advanced" />
                            <h3>Advanced Technologies</h3>
                            <p>React, Next.js va zamonaviy JS frameworklar.</p>
                        </div>
                        <div className="feature-card">
                            <img src={mobileImg} alt="Mobile" />
                            <h3>Mobile Development</h3>
                            <p>Android va iOS uchun ilovalar tayyorlash kursi.</p>
                        </div>
                    </div>
                </section>
            </main>

            <footer className="landing-footer">
                <p>&copy; 2026 SUVORIY TA'LIM. Barcha huquqlar himoyalangan.</p>
            </footer>
        </div>
    );
}

export default Landing;
